import { TraversalErrors } from 'stores/initialization/fieldErrorInitialization/FieldErrorStore'

interface FieldErrorReason {
  field: string
  reason: string
}

export const flattenFieldErrors = (
  errors: TraversalErrors
): FieldErrorReason[] =>
  Object.entries(errors).flatMap(([field, traversalErrors]) =>
    traversalErrors.map((error) => ({
      field,
      reason: error.id
    }))
  )
